import type { Icon } from '../../../src/lib/types'
export const mdiDotsVertical: Icon = {
  "id": "dots-vertical",
  "name": "Dots Vertical",
  "path": "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z",
  "as": [
    "ellipsis-vertical",
    "more-vert",
    "menu"
  ],
  "tags": []
}
export default mdiDotsVertical